import { defineComponent as n, useSlots as l, openBlock as t, createElementBlock as o, mergeProps as c, unref as a, renderSlot as s, createCommentVNode as d, createElementVNode as i } from "vue";
import "./ghl-ui.es240.js";
const h = {
  key: 0,
  class: "hl-card-header"
}, _ = { class: "hl-card-content" }, f = {
  key: 1,
  class: "hl-card-footer"
}, m = n({
  name: "UICard",
  inheritAttrs: !1
}), u = n({
  ...m,
  setup(p) {
    const r = l();
    return (e, k) => (t(), o("div", c(e.$attrs, { class: "hl-card" }), [
      a(r).header ? (t(), o("div", h, [
        s(e.$slots, "header")
      ])) : d("", !0),
      i("div", _, [
        s(e.$slots, "default")
      ]),
      a(r).footer ? (t(), o("div", f, [
        s(e.$slots, "footer")
      ])) : d("", !0)
    ], 16));
  }
}), $ = u;
export {
  $ as default
};
